// extracted by mini-css-extract-plugin
export default {"wrapper":"Svg3D_wrapper__IW+tK","visible":"Svg3D_visible__FXITP","float":"Svg3D_float__1h4CZ","float3d":"Svg3D_float3d__jvUAt"};